import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { passengerCMSApi } from "~/Services";

interface DocumentDetailsResponse {
  id?: number;
  mandarin_title: string;
  malay_title: string;
  english_title: string;
  description_mandarin: string;
  description_malay: string;
  description_english: string;
  published: boolean | string;
  airport: string;
  image: string;
}
export interface TravellerEssentialsList {
  id: string;
  link: string;
  document: string;
  image: string;
  parent_id: string;
  airport: string;
  created: string;
  published: string | boolean;
  updated: string;
}

const fetchSubCategoriesDetails = async (airport: string): Promise<any> => {
  const response: any = await passengerCMSApi.get(`/api/traveller-essentials-all-fields?airport=${airport}`);
  return response.data?.[0];
};
const fetchTravellerEssentialsList = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await passengerCMSApi.get(`/api/traveller-essential-paragraph/${id}`);
  return response.data[0];
};

const useSubCategoriesDocumentDetails = (
  airport: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["subCategoriesDocumentDetails", airport],
      enabled: false,
      queryFn: () => {
        return fetchSubCategoriesDetails(airport);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

const useTravellerEssentialsListDocumentDetails = (
  id: string,
  options?: UseQueryOptions<TravellerEssentialsList, DefaultError, TravellerEssentialsList, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<TravellerEssentialsList, DefaultError> => {
  return useQuery<TravellerEssentialsList, DefaultError, TravellerEssentialsList, QueryKey>(
    {
      queryKey: ["travellerEssentialsListDocumentDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchTravellerEssentialsList(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useSubCategoriesDocumentDetails, useTravellerEssentialsListDocumentDetails };
